export default "__VITE_ASSET__CZxLEhJy__"